import { axiosInstance } from './api';
import type { Paginated } from './types';

export interface RackDto {
  id: string;
  area: string;
  shelves: string[];
  name: string;
  rack_type: string;
  perspective_width: number;
  perspective_height: number;
  initial_width: number;
  initial_height: number;
  is_composite: boolean;
  predict_percentage: number;
  single_shelf?: boolean;
  merchandising_dashboard_id?: string | null;
}

export interface RackCreateDto {
  area: string;
  name: string;
  rack_type?: string | null;
  perspective_width?: number | null;
  perspective_height?: number | null;
  initial_width?: number | null;
  initial_height?: number | null;
  is_composite?: boolean;
  predict_percentage?: boolean;
  single_shelf?: boolean;
  merchandising_dashboard_id?: string | null;
}

export type RackPatchDto = Partial<RackCreateDto>;

export const listRacksByAreas = (areaIds: string[], pageSize = 1000) => {
  if (!areaIds || areaIds.length === 0) {
    return Promise.resolve({ data: { results: [] as RackDto[] } } as { data: Paginated<RackDto> });
  }
  const ids = areaIds.join(',');
  return axiosInstance.get<Paginated<RackDto>>(`/empty_shelf/rack/?area__in=${ids}&page_size=${pageSize}`);
};

export const listRacksByZone = (zoneId: string, pageSize = 1000) => {
  return axiosInstance.get<Paginated<RackDto>>(
    `/empty_shelf/rack/?area__camera__zone=${zoneId}&page_size=${pageSize}`,
  );
};

export const respawnRackGrafana = (rackId: string) => {
  return axiosInstance.post<{ status: string }>(
    `/empty_shelf/rack/${rackId}/respawn-grafana/`,
  );
};

export const createRack = (payload: RackCreateDto) => {
  return axiosInstance.post<RackDto>('/empty_shelf/rack/', payload);
};

export const patchRack = (rackId: string, payload: RackPatchDto) => {
  return axiosInstance.patch<RackDto>(`/empty_shelf/rack/${rackId}/`, payload);
};

/** keepArea — смена типа: снять только сущность, полигон оставить (#3222). */
export const deleteRack = (rackId: string, keepArea = false) => {
  return axiosInstance.delete(`/empty_shelf/rack/${rackId}/`, keepArea ? { params: { keep_area: 1 } } : undefined);
};
